import React, {useState} from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import {useAdminBucket} from "../../../components/utils";
import AudienceForm from '../../../components/data_products/audiences/AudienceForm';
import {
  useCreateDataVendorAudienceMutation,
  useGetDataVendorAudienceAggregationOptionsQuery,
  useGetDataVendorAudiencesQuery
} from "../../../api/dataVendorAudienceApiSlice";


export default function NewDataVendorAudience(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey } = useParams();
  const bucket = useAdminBucket(dataVendorKey)
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const { data: aggregationOptions = [] } = useGetDataVendorAudienceAggregationOptionsQuery(dataVendorKey)
  const { data: audiences = [] } = useGetDataVendorAudiencesQuery(dataVendorKey)

  const handleBack = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}`,
    state: {activeTab: 'audiences'}
  });

  const goToAudience = (data) => history.push(`/data_vendors/${dataVendorKey}/audiences/${data.key}`)

  const [createAudience] = useCreateDataVendorAudienceMutation()
  const submitProps = {
    handleSubmit: (data) => {
      createAudience({...data, dataVendorId: dataVendorKey}).unwrap()
        .then(goToAudience)
        .catch(error => {})
    },
    errors: {}
  }

  return (
    <>
      <Title
        main={t("menu.audiences")}
        sub={t("new")}
        group={false}
        onBack={handleBack}>
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <AudienceForm
        bucket={bucket}
        {...submitProps}
        setSubmitButtonProps={setSubmitButtonProps}
        aggregationOptions={aggregationOptions}
        audiences={audiences}
      />
    </>
  )
}

